import { NavigateBackLink } from '@exam-center/components';
import { useExamCenter } from '@exam-center/exam-center-details';
import { RecurringExamEventCreationLogic } from '@exam-center/exam-event-creation';
import { getExamEventDetailsTitle, getMonthOrder } from '@exam-center/exam-event-management';
import { useParams } from '@exam-center/router';
import { Flex, PageHeader } from '@shared/components';

export default function RecurringExamEventCreatePage() {
  const { year, month } = useParams(
    '/:examCenterCode/exam-events/years/:year/months/:month/recurring-create',
  );
  const { examCenter } = useExamCenter();
  const examCenterCode = examCenter.code;

  const yearNumber = parseInt(year);
  const monthNumber = getMonthOrder(month);

  return (
    <>
      <PageHeader
        title='สร้างรอบสอบแบบซ้ำ'
        subtitleSection={getExamEventDetailsTitle(yearNumber, month)}
        linkAdornment={
          <NavigateBackLink
            to='/:examCenterCode/exam-events/years/:year/months/:month'
            params={{ examCenterCode, year, month }}
          />
        }
      />
      <Flex
        sx={(theme) => ({
          flexDirection: 'column',
          gap: theme.spacing(4),
          p: theme.spacing(6),
        })}
      >
        <RecurringExamEventCreationLogic
          examCenterCode={examCenterCode}
          year={{ param: year, value: yearNumber }}
          month={{ param: month, value: monthNumber }}
        />
      </Flex>
    </>
  );
}
